import { usePunditUserContext } from "@/react/contexts/punditUserContext";

interface Member {
  admin: boolean;
  community_member_id: number;
}

export const useBlockDms = () => {
  const { currentCommunityMember } = usePunditUserContext();

  const canBlockMemberDm = (member: Member) => {
    const isCurrentCommunityMember =
      currentCommunityMember?.id === member.community_member_id;
    return !(isCurrentCommunityMember || member.admin);
  };

  return { canBlockMemberDm };
};
